import { shape, string } from 'prop-types';
import countryBasicInformationPropTypes from '../../country/proptypes/CountryPropTypes';

const regionBasicInformationPropTypes = {
  name: string,
  country: shape(countryBasicInformationPropTypes),
};

export default regionBasicInformationPropTypes;
